<template>
  <div class="userAvatar-wrapper">
    <div class="position-relative d-inline userAvatar-container">
      <div @click.stop="width > breakpoints.screen_tablet ? (dropdown = !dropdown) : (visible = true)"
        class="avatar position-relative"
        :class="`avatar-${dashStore.getUserProfil?.fullName?.slice(0, 1).toLowerCase()}`">
        {{ dashStore.getUserProfil?.fullName?.slice(0, 1).toUpperCase() }}
        <img v-if="dashStore.getUserProfil?.picture && !dashStore.getUserProfil?.picture.includes('placeholder')"
          :src="dashStore.getUserProfil.picture" alt="">
      </div>

      <OnClickOutside @trigger="dropdown = false" v-if="dropdown" class="dropdown-inner avatar-panel">
        <div class="d-flex px-3 py-12 border-bottom justify-content-start align-items-center gap-2">
          <div class="avatar" :class="`avatar-${dashStore.getUserProfil?.fullName?.slice(0, 1).toLowerCase()}`">
            {{ dashStore.getUserProfil?.fullName?.slice(0, 1).toUpperCase() }}
            <img v-if="dashStore.getUserProfil?.picture && !dashStore.getUserProfil?.picture.includes('placeholder')"
              :src="dashStore.getUserProfil.picture" alt="">
          </div>

          <div>
            <div class="d-flex gap-1">
              <h6 class="fsz-12 fw-semiBold">{{ dashStore.getUserProfil?.fullName }}</h6>
              <span v-if="dashStore.getUserProfil.isPro && dashStore.getUserProfil.marketplaces[0].verified"
                class="badge bg-warning-400 fsz-10">PRO</span>
            </div>

            <p class="fsz-12 text-gray-400 fw-semiBold mt-1">
              {{ dashStore.getUserProfil?.email }}
            </p>
          </div>
        </div>
        <div>
          <ul class="list-unstyled " @click="dropdown = false">
            <ul class="border-bottom inner-list">
              <li v-for="(item, index) in items" :key="index">
                <nuxt-link :class="`options d-flex align-items-center ${item.linkClass || ''}`" :to="item.url">
                  <span class="material-symbols-rounded fsz-18 me-2">{{ item.icon }}</span>
                  {{ item.label }}
                </nuxt-link>
              </li>
            </ul>

            <li class="log-out d-flex align-items-center" @click="logout">
              <span class="material-symbols-rounded fsz-18 me-2">{{ icons.logOut }}</span>
              Deconnexion
            </li>
          </ul>
        </div>
      </OnClickOutside>

      <ClientOnly>
        <Sidebar class="header-sideBar-menu bg-gray-100" v-model:visible="visible"
          :position="(width > breakpoints.screen_smallMobile && width < breakpoints.screen_tablet) ? 'right' : 'full'"
          :pt="{ mask: { class: 'avatarSideBar' } }">
          <template #header>
            <nuxt-link to="/">
              <img class="logo-black" src="~/assets/images/logos/top-auto-logo-black.svg" alt="" />
              <img class="logo-dark" src="~/assets/images/logos/LogoTA-Dark.svg" alt="" />
            </nuxt-link>
          </template>
          <div class="dropdown-inner avatar-panel mx-3" style="top: 80px !important; right: 0px !important; left: 0px;">
            <div class="d-flex px-3 py-12 border-bottom justify-content-start align-items-center gap-2">
              <div class="avatar  position-relative"
                :class="`avatar-${dashStore.getUserProfil?.fullName?.slice(0, 1).toLowerCase()}`">
                {{ dashStore.getUserProfil?.fullName?.slice(0, 1).toUpperCase() }}
                <img
                  v-if="dashStore.getUserProfil?.picture && !dashStore.getUserProfil?.picture.includes('placeholder')"
                  :src="dashStore.getUserProfil.picture" alt="">
              </div>
              <div>
                <div class="d-flex gap-1">
                  <h6 class="fsz-12 fw-semiBold">{{ dashStore.getUserProfil?.fullName }}</h6>
                  <span class="badge bg-warning-400 fsz-10"
                    v-if="dashStore.getUserProfil.marketplaces[0]?.verified">PRO</span>
                </div>

                <p class="fsz-12 text-gray-400 fw-semiBold mt-1">
                  {{ dashStore.getUserProfil?.email }}
                </p>
              </div>
            </div>
            <div class="border-bottom p-3">
              <nuxt-link
                class="btn xsmaller-btn btn-solid-primary-600 d-flex align-items-center justify-content-center fsz-14 w-100"
                @click="handleAddAnnounce">
                <span class="material-symbols-rounded fsz-20 me-1">{{ icons.plus }}</span>
                Ajouter une annonce
              </nuxt-link>
            </div>
            <ul v-if="width <= breakpoints.screen_smallMobile" class="border-bottom inner-list">
              <div
                class="tokens-container d-flex flex-row align-items-center gap-1 p-2"
                @click="visible = false; billingModal = true;">
                <div class="d-flex flex-row justify-content-center align-items-center"
                  style="width: 22px; height: 22px;">
                  <img src="~/assets/images/logos/TopAuto_token_.svg" />
                </div>
                <span class="fsz-14 text-gray-900 lh-base d-flex flex-row gap-1"><b>{{ totalCredits }}</b> Credits</span>
              </div>
              <li class="sidebar-notification d-flex align-items-center justify-content-between ">
                <div class="options d-flex align-items-center justify-content-between w-100 gap-1 ps-2"
                  @click="openDialog">
                  <div class="d-flex justify-content-between align-items-center gap-1">
                    <span class="material-symbols-rounded fsz-20">{{ icons.bell }}</span>
                    <p>Notifications</p>
                  </div>
                  <Badge class="text-white bg-danger-600 fsz-12">{{ notifyStore.getIsNotRead }}</Badge>
                </div>
              </li>
            </ul>
            <div>
              <ul class="list-unstyled ">
                <ul class="border-bottom inner-list">
                  <li v-for="(item, index) in items" :key="index" @click="visible = false">
                    <nuxt-link :class="`options d-flex align-items-center ${item.linkClass || ''}`" :to="item.url">
                      <span class="material-symbols-rounded fsz-18 me-2">{{ item.icon }}</span>
                      {{ item.label }}
                    </nuxt-link>
                  </li>
                </ul>

                <li class="log-out d-flex align-items-center" @click="logout">
                  <span class="material-symbols-rounded fsz-18 me-2">{{ icons.logOut }}</span>
                  Deconnexion
                </li>
              </ul>
            </div>
          </div>
        </Sidebar>
      </ClientOnly>
    </div>
    <DialogsBilling :visible="billingModal" @update:visible="(e: any) => billingModal = e" />
    <DialogsNotification :visible="isDetailNotifVisible" @update:visible="(e: any) => isDetailNotifVisible = e" />
  </div>
</template>

<script setup lang="ts">
import { trackAnnouncementStarted } from '~/composables/useFirebaseAnalytics'
import { useWindowSize } from '@vueuse/core'
import { OnClickOutside } from '@vueuse/components'
import { breakpoints } from '~/utils/breakpoints.js'
import { ref, computed, reactive } from 'vue'

interface MenuItem {
  label: string;
  class: string;
  url: string;
  icon: string;
  linkClass?: string;
}

const dashStore = useDashboardStore()
const { sendAddAnnouncementTelegram } = useAddAnnouncementTelegram();

const cookieId = useCookie("userId")

const cookies = useCookie('userToken')
const windowSize = useWindowSize({
  initialWidth: breakpoints.screen_laptop + 1,
  initialHeight: 900
})
const width = computed(() =>
  windowSize.width.value || breakpoints.screen_laptop + 1
)

const dropdown = ref(false)
const visible = ref(false)
const isDetailNotifVisible = ref(false)
const totalCredits = computed(() => {
  const free = Number(dashStore.getUserProfil?.freeCredits || 0)
  const additional = Number(dashStore.getUserProfil?.additionalCredits || 0)
  return free + additional
})

const icons = reactive({
  bell: 'notifications',
  messege: 'mail',
  currency: 'paid',
  car: 'directions_car',
  home: 'home',
  store: 'storefront',
  cog: 'settings',
  logOut: 'logout',
  savedSearch: 'search',
  bookMark: 'bookmark',
  plus: 'add',
  subscription: 'credit_card',
  billing: 'receipt_long',
})
const billingModal = ref(false)
const notifyStore = useNotifyStore()

const handleAddAnnounce = () => {
  if (dashStore.getUserProfil.id) {
    void sendAddAnnouncementTelegram('manuel')
    trackAnnouncementStarted({ announce_type_created: 'Manuel' })
    navigateTo('/listing-form/vehicle-data?fresh=true')
  } else {
    navigateTo('authentication/signup')
  }
}

const items = ref<MenuItem[]>([
  {
    label: 'Tableau de bord',
    class: '',
    url: '/dashboard/home',
    icon: icons.home
  },
  {
    label: 'Mes annonces',
    class: '',
    url: '/dashboard/items',
    icon: icons.car
  },
  {
    label: 'Mes offres',
    class: 'border-bottom',
    url: '/dashboard/offers',
    icon: icons.currency
  },
  {
    label: 'Messages',
    class: 'border-bottom',
    url: '/dashboard/inbox',
    icon: icons.messege
  },
  {
    label: 'Recherches sauvegardées',
    class: 'border-bottom',
    url: '/dashboard/savedsearches',
    icon: icons.savedSearch
  },
  {
    label: 'Annonces sauvegardées',
    class: 'border-bottom',
    url: '/dashboard/saveditems',
    icon: icons.bookMark
  },
  {
    label: 'Abonnements & transactions',
    class: '',
    url: '/dashboard/parameter/abonnement_et_transaction',
    icon: icons.subscription
  },
  ...(!dashStore.getUserProfil?.isPro ? [] : [{
    label: 'Informations de facturation',
    class: '',
    url: '/dashboard/parameter/Informations_de_facturation',
    icon: icons.billing
  }]),
  {
    label: 'Paramètres',
    class: 'border-bottom',
    url: '/dashboard/parameter/information_personnel',
    icon: icons.cog
  }
])

const marketPlace = {
  label: 'Creer votre espace pro',
  class: 'border-bottom',
  url: '/marketplace/builder',
  icon: icons.store,
  linkClass: 'marketplace-btn'
}

const openDialog = () => {
  isDetailNotifVisible.value = !isDetailNotifVisible.value
  visible.value = !visible.value
}

const logout = () => {
  try {
    cookieId.value = null
    cookies.value = null
    reloadNuxtApp({
      path: "/",
      ttl: 1000,
    })
  } catch (error) {
    console.error('Erreur de deconnexion:', error)
  }
}

onMounted(() => {
  if (dashStore.getUserProfil.isPro) {
    if (dashStore.getUserProfil.marketplaces[0]) {
      marketPlace.label = 'Modifier votre espace pro'
    }
    items.value.push(marketPlace)
  }
})
</script>

<style scoped>
.dropdown-inner {
  background-color: white;
  position: absolute;
  right: 0 !important;
  top: 40px;
  z-index: 1030;
  border-radius: 8px;
  box-shadow: 2px 2px 5px rgba(10, 10, 10, 0.1);

  .badge {
    height: auto;
  }
}

.avatar-panel {
  min-width: 270px !important;
  overflow-y: auto;
  max-height: calc(100vh - 100px);
}

/* Specific styles for avatar panel inside the sidebar on mobile */
:deep(.header-sideBar-menu) .avatar-panel {
  position: static;
  overflow-y: auto;
  max-height: calc(100vh - 100px);
  box-shadow: none;
  border-radius: 0;
}
</style>
